import React from 'react';
import "../style/footer.css";
import { useNavigate } from 'react-router-dom';
import { Typography, Box, Grid, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
      <Box sx={{ background: "#1B1B1B",  }}>
        <div className="container-footer">
          <Grid container className="footer__bottom" style={{textAlign: 'center'}}>
            <Grid containerxs={12} md={12} lg={12} className="footer footer-bottom-endcontainer">
              {/* <Grid className="footer footer-bottom-end-faq">
                <Typography className="faq" style={{ border: "none", fontSize: 14 }}><Link href="mailto:mplb@martinrea.com" style={{color: '#fff'}}>{t("Contact Us")}</Link> </Typography>
              </Grid> */}
              <Grid className="footer footer-bottom-end-faq">
                    <Typography className="copyrights">Helpdesk Email: <b style={{color: 'rgb(5, 170, 232)'}}>mplb@martinrea.com</b></Typography>
               </Grid>
              <Grid className="footer footer-bottom-end-copyrights">
                {/* <Typography className="copyrights" > {t("Copyrights")} © {new Date().getFullYear()} {t("All Rights Reserved by")}{" "}
                  <b className="copyright-app" onClick={()=>{navigate("/home")  }} >MARTINREA®</b>
                </Typography> */}
                <Typography className="copyrights" > <b>© 2026, Martinrea International Inc.</b>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Box>
  );
};

export default Footer;